import { NotificationIcon as CoreNotificationIcon } from '@zhiyue/core';
import React from 'react';
import { useOpenPlatformAccessToken } from '@/contexts/openPlatform';

type NotificationIconProps = Omit<
  React.ComponentProps<typeof CoreNotificationIcon>,
  'token'
>;

const NotificationIcon: React.FC<NotificationIconProps> = (props) => {
  const token = useOpenPlatformAccessToken();

  if (!token) {
    return null;
  }

  return <CoreNotificationIcon {...props} token={token} />;
};

export default NotificationIcon;
